import useClusterConfig from 'hooks/useClusterConfig';

export type Config = {
  stream_id: string;
};

const INVESTIGATION_MESSAGES_STREAM_CONFIG =
  'org.graylog.plugins.securityapp.migrations.InvestigationMessagesStreamConfig';

const useInvestigationsMessagesConfig = (): { data: Config; isInitialLoading: boolean } =>
  useClusterConfig<Config>(INVESTIGATION_MESSAGES_STREAM_CONFIG);
export default useInvestigationsMessagesConfig;
